import axios from "axios";
import React, { useState, useEffect } from "react";
import { Form, Button } from "react-bootstrap";
import { environment } from "../../environment";
import { Link } from "react-router-dom";
import Select from "react-select";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Country, State, City } from "country-state-city";
import "./LeadExecutive/leadexecutive.css";
import NavbarNew from "../Components/NavbarNew";

const MySwal = withReactContent(Swal);

const EditUserSysAdmin = ({ history, match }) => {
  const [name, setname] = useState("");
  const [fname, setFname] = useState("");
  const [lname, setLname] = useState("");
  const [role, setrole] = useState({});
  const [roleCount, setRoleCount] = useState({});
  const [email, setmail] = useState("");
  const [phone, setphone] = useState("");
  const [dob, setdob] = useState("");
  const [postcountry, setPostCountry] = useState("");
  const [countrycode, setCountryCode] = useState("");
  const [dap_states, setDapState] = useState([]);
  const [dap_countries, setDapCountries] = useState("");
  const [dap_city, setDapCity] = useState([]);
  const [poststate, setPostState] = useState("");
  const [postcity, setPostCity] = useState("");
  const [zip, setzip] = useState("");
  const [address, setAddress] = useState("");
  const [pwd, setpassword] = useState("");
  const [nameErrors, setNameErrors] = useState({});
  const [fnameErrors, setFNameErrors] = useState({});
  const [lnameErrors, setLNameErrors] = useState({});
  const [roleErrors, setroleErrors] = useState({});
  const [emailErrors, setemailErrors] = useState({});
  const [passwordErrors, setpasswordErrors] = useState({});
  const [phoneErrors, setphoneErrors] = useState({});
  const [organization, setOrganization] = useState("");
  const [showOrganization, setShowOrganization] = useState("none");
  const [organizationErrors, setOrganizationErrors] = useState({});
  const [showPassword, setShowPassword] = useState("block");
  const [userType, setUserType] = useState("");

  let roles = [];
  const userKaData = JSON.parse(localStorage.getItem("user"));

  if (userType == "PARTNER") {
    roles = [
      {
        role: "PARTNER",
        role_value: "PARTNER",
      },
    ];
  } else {
    roles = [
      // {
      //   role: "Lead Executive",
      //   role_value: "LEAD_EXECUTIVE",
      // },
      {
        role: "Support Admin",
        role_value: "SUPPORT_ADMIN",
      },
      {
        role: "IT Executive",
        role_value: "IT_EXECUTIVE",
      },
      {
        role: "Vendor",
        role_value: "VENDOR",
      },
      {
        role: "LOGISTIC MANAGER",
        role_value: "LOGISTIC_MANAGER",
      },
    ];
  }

  let countries = [];
  countries = Country.getAllCountries();
  const selectCountry = (e) => {
    setDapCountries(Country.getAllCountries());
    setDapState(State.getStatesOfCountry(e.id));
    setCountryCode(e.id);
    setPostCountry(e.label);
  };
  const selectRegion = (e) => {
    setDapCity(City.getCitiesOfState(countrycode, e.id));
    setPostState(e.label);
  };
  const selectCity = (e) => {
    setPostCity(e.label);
  };
  const formValidation = () => {
    let isValid = true;
    const nameErrors = {};
    const fnameErrors = {};
    const lnameErrors = {};
    const roleErrors = {};
    const emailErrors = {};
    // const passwordErrors = {};
    const phoneErrors = {};
    setNameErrors("");
    setroleErrors("");
    setemailErrors("");
    setroleErrors("");
    setphoneErrors("");
    if (fname == "") {
      fnameErrors.noName = "First name is required";
      isValid = false;
      setFNameErrors(fnameErrors);
      console.log(isValid);
    }
    if (lname == "") {
      lnameErrors.noName = "Last name is required";
      isValid = false;
      setLNameErrors(lnameErrors);
      console.log(isValid);
    }
    if (role == "") {
      roleErrors.noName = "Role is required";
      isValid = false;
      setroleErrors(roleErrors);
      console.log(isValid);
    }
    if (email == "") {
      emailErrors.noName = "Email is required";
      isValid = false;
      setemailErrors(emailErrors);
      console.log(isValid);
    }
    if (role.label != "PARTNER") {
      if (pwd == "") {
        passwordErrors.noName = "Password is required";
        isValid = false;
        setpasswordErrors(passwordErrors);
        console.log(isValid);
      }
    }
    if (email == "") {
      emailErrors.noEmail = "* Email Id required";
      isValid = false;
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      emailErrors.invalidEmail = "* Email address is invalid";
      isValid = false;
      console.log(isValid);
    }
    if (phone != "") {
      var phoneno = /^\d{10}$/;
      if (!phone.match(phoneno)) {
        phoneErrors.noName = "Provide a Proper Phone No.";
        isValid = false;
        setphoneErrors(phoneErrors);
        console.log(isValid);
      }
    }
    if (showOrganization == "block") {
      if (organization == "") {
        organizationErrors.noOrg = "Organization is required";
        isValid = false;
        setOrganizationErrors(organizationErrors);
        console.log(isValid);
      }
    }
    console.log(isValid);
    return isValid;
  };
  const UpdateLeadExecutive = () => {
    let validform = formValidation();
    if (validform) {
      axios
        .put(
          environment.dap_url +
            "crm_api/updateLeadExecutive?id=" +
            match.params.id,
          {
            email: email,
            password: pwd,
            userFirstName: fname,
            userLastName: lname,
            organization: organization,
            city: postcity,
            state: poststate,
            country: postcountry,
            zip: zip,
            address: address,
            phone: phone,
            DOB: dob,
            userType: role.value,
          }
        )
        .then((res) => {
          console.log(res.data);
          if (res.data.error) {
            MySwal.fire({
              title: <p>Given Mail id already exist</p>,
              type: "success",
            });
          } else {
            MySwal.fire({
              title: <p>User Updated</p>,
              type: "success",
            });
            history.push("/manage-users");
          }
        })
        .catch((err) => {
          console.log(err);
          MySwal.fire({
            title: <p>{err?.response?.data?.message}</p>,
            type: "error",
          });
        });
    }
  };
  const setrole1 = (e) => {
    console.log(e.value);
    roles.forEach((utype) => {
      if (utype.role_value == e.value) {
        console.log("hii");
        setrole({ label: e.label, value: e.value });
        if (e.value == "PARTNER") {
          setShowOrganization("block");
        } else {
          setShowOrganization("none");
          setOrganization("");
        }
        if (e.value == "PARTNER") {
          setShowPassword("none");
          setpassword("");
        } else {
          setShowPassword("block");
        }
      }
    });
    // setrole(dtype);
  };

  useEffect(() => {
    fetchExecutiveByid(match.params.id);
  }, []);
  let roleindex = -1;
  const fetchExecutiveByid = async (id) => {
    axios
      .get(environment.dap_url + "users/" + id)
      .then((res) => {
        console.log(res.data);
        roles.forEach((item) => {
          if (item.role_value == res.data.userType) {
            setRoleCount({ label: item.role, value: item.role_value });
          }
        });
        setname(res.data.userFirstName);
        setFname(res.data.userFirstName);
        setLname(res.data.userLastName);
        setmail(res.data.email);
        setphone(res.data.phone);
        setdob(res.data.DOB);
        setzip(res.data.zip);
        setAddress(res.data.address);
        setPostCountry(res.data.country);
        setPostState(res.data.state);
        setPostCity(res.data.city);
        setOrganization(res.data.organization);
        setUserType(res.data.userType);
        if (res.data.userType == "PARTNER") {
          setShowOrganization("block");
        } else {
          setShowOrganization("none");
        }

        roles.forEach((utype) => {
          if (utype.role_value == res.data.userType) {
            setrole({ label: utype.role, value: utype.role_value });
          } else if (res.data.userType == "PARTNER") {
            setrole({ label: "PARTNER", value: "PARTNER" });
          }
        });
        if (res.data.userType == "PARTNER") {
          setShowPassword("none");
        }
        if (res.data.userType == "LEAD_EXECUTIVE") {
        }
        // alert(res.data.userType);

        // alert(roleindex);
      })
      .catch(function (error) {
        MySwal.fire({
          title: <p>{error.message}</p>,
          type: "error",
        });
      });
  };
  return (
    <>
      <div className="container-fluid">
        <NavbarNew />
        <Link to="/manage-users" className="btn btn-light my-3">
          Go Back
        </Link>

        <div className="row">
          <div className="col-md-12 grid-margin stretch-card">
            <div className="card">
              <h4 className="card-title">Edit</h4>

              <div className="row">
                {/* <div className="col-md-6">
                    <Form.Group controlId="consignee">
                      <Form.Label>Name*</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Name"
                        required
                        value={name}
                        onChange={(e) => setname(e.target.value)}
                      ></Form.Control>
                      <div>
                        {Object.keys(nameErrors).map((key) => {
                          return (
                            <div style={{ color: "red" }}>
                              {nameErrors[key]}
                            </div>
                          );
                        })}
                      </div>
                    </Form.Group>
                  </div> */}
                <div className="col-md-6">
                  <Form.Group controlId="consignee">
                    <Form.Label>Email*</Form.Label>
                    <Form.Control
                      type="email"
                      placeholder="Email"
                      value={email}
                      onChange={(e) => setmail(e.target.value)}
                      readOnly
                    ></Form.Control>
                    <div>
                      {Object.keys(emailErrors).map((key) => {
                        return (
                          <div style={{ color: "red" }}>{emailErrors[key]}</div>
                        );
                      })}
                    </div>
                  </Form.Group>
                </div>
                <div className="col-md-6">
                  <Form.Group controlId="consignee">
                    <Form.Label>Role*</Form.Label>
                    <Select
                      options={roles.map((r) => ({
                        label: r.role,
                        value: r.role_value,
                      }))}
                      value={role}
                      onChange={(e) => setrole1(e)}
                      placeholder="Role"
                    />
                    <div>
                      {Object.keys(roleErrors).map((key) => {
                        return (
                          <div style={{ color: "red" }}>{roleErrors[key]}</div>
                        );
                      })}
                    </div>
                  </Form.Group>
                </div>
              </div>
              <div className="row" style={{ display: showOrganization }}>
                <div className="col">
                  <Form.Group>
                    <Form.Label>Organization*</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Organization name"
                      value={organization}
                      onChange={(e) => setOrganization(e.target.value)}
                    />
                    <div>
                      {Object.keys(organizationErrors).map((key) => {
                        return (
                          <div style={{ color: "red" }}>
                            {organizationErrors[key]}
                          </div>
                        );
                      })}
                    </div>
                  </Form.Group>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <Form.Group controlId="consignee">
                    <Form.Label>First Name*</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="First Name"
                      required
                      value={fname}
                      onChange={(e) => setFname(e.target.value)}
                    ></Form.Control>
                    <div>
                      {Object.keys(fnameErrors).map((key) => {
                        return (
                          <div style={{ color: "red" }}>{fnameErrors[key]}</div>
                        );
                      })}
                    </div>
                  </Form.Group>
                </div>
                <div className="col-md-6">
                  <Form.Group controlId="consignee">
                    <Form.Label>Last Name*</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Last Name"
                      required
                      value={lname}
                      onChange={(e) => setLname(e.target.value)}
                    ></Form.Control>
                    <div>
                      {Object.keys(lnameErrors).map((key) => {
                        return (
                          <div style={{ color: "red" }}>{lnameErrors[key]}</div>
                        );
                      })}
                    </div>
                  </Form.Group>
                </div>
              </div>
              <div className="row" style={{ display: showPassword }}>
                <div className="col-md-12">
                  <Form.Group controlId="consignee">
                    <Form.Label>Password*</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="password"
                      value={pwd}
                      onChange={(e) => setpassword(e.target.value)}
                    ></Form.Control>
                    <div>
                      {Object.keys(passwordErrors).map((key) => {
                        return (
                          <div style={{ color: "red" }}>
                            {passwordErrors[key]}
                          </div>
                        );
                      })}
                    </div>
                  </Form.Group>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <Form.Group controlId="consignee">
                    <Form.Label>Phone</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Phone"
                      value={phone}
                      onChange={(e) => setphone(e.target.value)}
                    ></Form.Control>
                    <div>
                      {Object.keys(phoneErrors).map((key) => {
                        return (
                          <div style={{ color: "red" }}>{phoneErrors[key]}</div>
                        );
                      })}
                    </div>
                  </Form.Group>
                </div>
                <div className="col-md-6">
                  <Form.Group controlId="consignee">
                    <Form.Label>DOB</Form.Label>
                    <Form.Control
                      type="date"
                      placeholder=""
                      value={dob}
                      onChange={(e) => setdob(e.target.value)}
                    ></Form.Control>
                  </Form.Group>
                </div>
              </div>
              <div className="row">
                <div className="col-md-4">
                  <Form.Group controlId="countri">
                    <Form.Label>Country</Form.Label>
                    <Select
                      options={countries.map((element) => ({
                        id: element.isoCode,
                        value: element.name,
                        label: element.name,
                      }))}
                      value={{
                        label: postcountry,
                        value: postcountry,
                      }}
                      onChange={(e) => selectCountry(e)}
                      placeholder="Country"
                    />
                  </Form.Group>
                </div>
                <div className="col-md-4">
                  <Form.Group controlId="name">
                    <Form.Label>State</Form.Label>
                    <Select
                      options={dap_states.map((element) => ({
                        id: element.isoCode,
                        value: element.name,
                        label: element.name,
                      }))}
                      value={{
                        label: poststate,
                        value: poststate,
                      }}
                      onChange={(e) => selectRegion(e)}
                      // defaultValue={dap_deviceList[0].name}
                      defaultValue="hi there"
                      placeholder="State"
                    />
                  </Form.Group>
                </div>
                <div className="col-md-4">
                  <Form.Group controlId="name">
                    <Form.Label>City</Form.Label>
                    <Select
                      options={dap_city.map((element) => ({
                        id: element.isoCode,
                        value: element.name,
                        label: element.name,
                      }))}
                      onChange={(e) => selectCity(e)}
                      value={{ label: postcity, value: postcity }}
                      defaultValue="hi there"
                      placeholder="City"
                    />
                  </Form.Group>
                </div>
              </div>
              <div className="row">
                <div className="col-md-4">
                  <Form.Group controlId="consignee">
                    <Form.Label>Zip</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Zip"
                      value={zip}
                      onChange={(e) => setzip(e.target.value)}
                    ></Form.Control>
                  </Form.Group>
                </div>
                <div className="col-md-4">
                  <Form.Group controlId="consignee">
                    <Form.Label>Address</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Address"
                      value={address}
                      onChange={(e) => setAddress(e.target.value)}
                    ></Form.Control>
                  </Form.Group>
                </div>
                <div className="col-md-4">
                  <Button
                    variant="primary"
                    style={{ marginTop: 22 }}
                    onClick={UpdateLeadExecutive}
                  >
                    SAVE
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditUserSysAdmin;
